import { QueryParams } from '@domain/types';
import { Http } from '@services/http/http.service';

const path = '/organizations';

export async function getOrganizations(searchParams: QueryParams) {
  return await Http.getInstance().get({ path, searchParams });
}
